module.exports = __webpack_public_path__ + "img/slider (4).f4c240e9.png";